import React, { useState, useEffect } from "react";
import "./css/styles.css";
import { DataGrid } from "@mui/x-data-grid";
import CameraAltIcon from "@mui/icons-material/CameraAlt";
import { Link } from "react-router-dom";
import CircularProgress from '@mui/material/CircularProgress';

import {
  Card,
  Dialog,
  DialogActions,
  DialogTitle,
  Button,
  TextField,
  FormControl,
  Box,
  Modal,
} from "@mui/material";

import PortraitIcon from "@mui/icons-material/Portrait";
import { modalstyle, muiAbtn, muiBbtn, starIcon } from "./style";
// import CheckCircleIcon from "@mui/icons-material/CheckCircle";
// import CancelIcon from "@mui/icons-material/Cancel";
// import RemoveRedEyeIcon from "@mui/icons-material/RemoveRedEye";
// import EditIcon from "@mui/icons-material/Edit";
// import CloseIcon from "@mui/icons-material/Close";
// import StarIcon from "@mui/icons-material/Star";
// import AddIcon from "@mui/icons-material/Add";
// import Rating from "@mui/material/Rating";
import Chart from "./Chart";

import {
  collection,
  getDocs,
  setDoc,
  onSnapshot,
  addDoc,
  updateDoc,
  doc,
  query,
  orderBy,
  deleteDoc,
  limit,
  where,
  getDoc,
} from "firebase/firestore";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { db } from "../firebase";
import FiberManualRecordIcon from "@mui/icons-material/FiberManualRecord";
const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 500,
  bgcolor: "#fff",
  boxShadow: 24,
  p: 4,
  boxShadow: "rgba(149, 157, 165, 0.2) 0px 8px 24px",
};

export default function Dashboard() {
  // const [rows, setRows] = useState([]);
  const [Category, setCategory] = useState("");
  const [loading, setLoading] = useState(false); ///To check if data if loaded or not from collection.
  const [rowId, setrowId] = useState(-1);
  const [countProduct, setCountProduct] = useState("");
  const [countOrders, setCountOrders] = useState("");
  const [countUsers, setCountUsers] = useState("");
  const [countReviews, setCountReviews] = useState("");


  useEffect(() => {

    onSnapshot(collection(db, "products"), (data) => {
      setCountProduct(data.size);
    });

    onSnapshot(collection(db, "orders"), (data) => {
      setCountOrders(data.size);
    });

    onSnapshot(collection(db, "users"), (data) => {
      setCountUsers(data.size);
    });


  }, []);

  const [open, setOpen] = useState(false);
  const [UnaprovedID, setUnaprovedID] = useState("");

  const handleOpen = (index) => {
    setrowId(index);
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  };

  const [openDialog, setOpenDialog] = React.useState(false);

  const handleClickOpen = (id) => {
    setOpenDialog(true);
    setUnaprovedID(id);
  };

  const handleCloseDialog = () => {
    setOpenDialog(false);
    setUnaprovedID("");
  };

  const approveCategory = (id) => {
    // updateDoc(doc(db, "Category", id), { status: "approved" }).then(() => {
    toast.success("Category Approved");

    // setRows(
    //   rows.map((item) => {
    //     if (item.documentId === id) {
    //       return { ...item, status:"approved" };
    //     } else {
    //       return item;
    //     }
    //   })
    // );

    //     });
  };
  const rejectCategory = () => {
    //     updateDoc(doc(db, "Category", UnaprovedID), { status: "rejected" }).then(
    //       () => {
    toast.error("Category Rejected");
    handleCloseDialog();

    //         setRows(
    //           rows.map((item) => {
    //             if (item.documentId === UnaprovedID) {
    //               return { ...item, status:"rejected" };
    //             } else {
    //               return item;
    //             }
    //           })
    //         );

    //       }
    //     );
  };

  return (
    <div
      style={{
        width: "100%",
        padding: 40,
        paddingRight: 20,
        backgroundColor: "#212C62",
      }}
    >
      <ToastContainer
        position="top-center"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="colored"
      />

      <Card style={{ padding: 40, borderRadius: 10 }}>
        <div className="row d-flex justify-content-between">
          <div className="col-12 mb-4 py-4">
            <h1 className="" style={{ textAlign: "left", color: "#212C62" }}>
              <b>Overview</b>
            </h1>
          </div>
        </div>
        <div className="row mt-2">
          <div role="button" className=" col-sm-3 ">
            <Link
              to="/AllProducts"
              style={{ textDecoration: "none", color: "black" }}
            >
              <div className="border rounded-3 pointer d-flex justify-content-center flex-wrap p-4">
                <div className="w-100 text-center">
                  <h5 className="text-muted">Product</h5>
                </div>
                <div className="w-100 font-weight-bold text-center">
                <h2>{countProduct?countProduct:<CircularProgress />}</h2>

                </div>
              </div>
            </Link>
          </div>
          <div role="button" className=" col-sm-3 ">
            <Link
              to="/AllOrders"
              style={{ textDecoration: "none", color: "black" }}
            >
              <div className="border rounded-3 pointer d-flex justify-content-center flex-wrap p-4">
                <div className="w-100 text-center">
                  <h5 className="text-muted">Orders</h5>
                </div>
                <div className="w-100 font-weight-bold text-center">
                <h2>{countOrders?countOrders:<CircularProgress />}</h2>

                </div>
              </div>
            </Link>
          </div>
          <div role="button" className=" col-sm-3 ">
            <Link
              to="/AllUsers"
              style={{ textDecoration: "none", color: "black" }}
            >
              <div className="border rounded-3 pointer d-flex justify-content-center flex-wrap p-4">
                <div className="w-100 text-center">
                  <h5 className="text-muted">Users</h5>
                </div>
                <div className="w-100 font-weight-bold text-center">
                <h2>{countUsers?countUsers:<CircularProgress />}</h2>

                </div>
              </div>
            </Link>
          </div>
          <div role="button" className=" col-sm-3 ">
            <Link
              to="/AllFeedbacks"
              style={{ textDecoration: "none", color: "black" }}
            >
              <div className="border rounded-3 pointer d-flex justify-content-center flex-wrap p-4">
                <div className="w-100 text-center">
                  <h5 className="text-muted">On Hold Reviews</h5>
                </div>
                <div className="w-100 font-weight-bold text-center">
                  <h2>01</h2>
                </div>
              </div>
            </Link>
          </div>
        </div>

        <div className="row p-2">
          <div className="p-4 border rounded-3">
            <div className="mb-2">
              <h3>Today's Trend</h3>

              <small className="text-muted">
                As of {new Date().toLocaleString() + ""}
              </small>
            </div>
            <Chart />
          </div>
        </div>
      </Card>
    </div>
  );
}
